import { LogTypeEnum } from 'libs/monitoring/errors'
import { eventMonitoring } from 'libs/monitoring/services'
import { buildPlaceUrl, BuildSearchAddressProps } from 'libs/place/buildUrl'

import { Collection, SuggestedPlace } from './types'

const REGEX_STARTING_WITH_NUMBERS = /^\d/

const buildSuggestedPlaces = (collection: Collection): SuggestedPlace[] =>
  // @ts-expect-error: because of noUncheckedIndexedAccess
  collection.features.map(({ geometry, properties }) => {
    const { city, context, name, type } = properties
    const detailedPlace = type === 'street' || type === 'housenumber' || type === 'locality'
    const [, department] = context.replaceAll(/\s+/g, '').split(',') // department number, department name, region
    const [longitude, latitude] = geometry.coordinates

    const shortName = detailedPlace ? name : city
    const longName = detailedPlace ? `${name}, ${city}` : city

    const placeNameStartsWithNumbers = REGEX_STARTING_WITH_NUMBERS.test(shortName)

    return {
      label: placeNameStartsWithNumbers ? shortName : longName,
      info: placeNameStartsWithNumbers ? city : department || '',
      type: type,
      geolocation: { longitude, latitude },
    }
  })

export const fetchPlaces = async ({
  query,
}: BuildSearchAddressProps): Promise<SuggestedPlace[]> => {
  const url = buildPlaceUrl({ query })

  try {
    const response = await fetch(url)
    const collection: Collection = await response.json()
    return buildSuggestedPlaces(collection)
  } catch (error) {
    eventMonitoring.captureException('Failed to fetch places', {
      level: LogTypeEnum.INFO,
      extra: { error },
    })
    return []
  }
}
